import styled from '@mui/system/styled';

export const GlobalFiltersCnt = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '20px 30px',
}));
